export const languagelist=[
    {
        "code": "ab",
        "name": ""
    },
    {
        "code": "ace",
        "name": ""
    },
    {
        "code": "ach",
        "name": ""
    },
    {
        "code": "af",
        "name": ""
    },
    {
        "code": "ak",
        "name": ""
    },
    {
        "code": "alz",
        "name": ""
    },
    {
        "code": "am",
        "name": ""
    },
    {
        "code": "ar",
        "name": ""
    },
    {
        "code": "as",
        "name": ""
    },
    {
        "code": "awa",
        "name": ""
    },
    {
        "code": "ay",
        "name": ""
    },
    {
        "code": "az",
        "name": ""
    },
    {
        "code": "ba",
        "name": ""
    },
    {
        "code": "ban",
        "name": ""
    },
    {
        "code": "bbc",
        "name": ""
    },
    {
        "code": "be",
        "name": ""
    },
    {
        "code": "bem",
        "name": ""
    },
    {
        "code": "bew",
        "name": ""
    },
    {
        "code": "bg",
        "name": ""
    },
    {
        "code": "bho",
        "name": ""
    },
    {
        "code": "bik",
        "name": ""
    },
    {
        "code": "bm",
        "name": ""
    },
    {
        "code": "bn",
        "name": ""
    },
    {
        "code": "br",
        "name": ""
    },
    {
        "code": "bs",
        "name": ""
    },
    {
        "code": "bts",
        "name": ""
    },
    {
        "code": "btx",
        "name": ""
    },
    {
        "code": "bua",
        "name": ""
    },
    {
        "code": "ca",
        "name": ""
    },
    {
        "code": "ceb",
        "name": ""
    },
    {
        "code": "cgg",
        "name": ""
    },
    {
        "code": "chm",
        "name": ""
    },
    {
        "code": "ckb",
        "name": ""
    },
    {
        "code": "cnh",
        "name": ""
    },
    {
        "code": "co",
        "name": ""
    },
    {
        "code": "crh",
        "name": ""
    },
    {
        "code": "crs",
        "name": ""
    },
    {
        "code": "cs",
        "name": ""
    },
    {
        "code": "cv",
        "name": ""
    },
    {
        "code": "cy",
        "name": ""
    },
    {
        "code": "da",
        "name": ""
    },
    {
        "code": "de",
        "name": ""
    },
    {
        "code": "din",
        "name": ""
    },
    {
        "code": "doi",
        "name": ""
    },
    {
        "code": "dov",
        "name": ""
    },
    {
        "code": "dv",
        "name": ""
    },
    {
        "code": "dz",
        "name": ""
    },
    {
        "code": "ee",
        "name": ""
    },
    {
        "code": "el",
        "name": ""
    },
    {
        "code": "en",
        "name": ""
    },
    {
        "code": "eo",
        "name": ""
    },
    {
        "code": "es",
        "name": ""
    },
    {
        "code": "et",
        "name": ""
    },
    {
        "code": "eu",
        "name": ""
    },
    {
        "code": "fa",
        "name": ""
    },
    {
        "code": "ff",
        "name": ""
    },
    {
        "code": "fi",
        "name": ""
    },
    {
        "code": "fil",
        "name": ""
    },
    {
        "code": "fj",
        "name": ""
    },
    {
        "code": "fr",
        "name": ""
    },
    {
        "code": "fy",
        "name": ""
    },
    {
        "code": "ga",
        "name": ""
    },
    {
        "code": "gaa",
        "name": ""
    },
    {
        "code": "gd",
        "name": ""
    },
    {
        "code": "gl",
        "name": ""
    },
    {
        "code": "gn",
        "name": ""
    },
    {
        "code": "gom",
        "name": ""
    },
    {
        "code": "gu",
        "name": ""
    },
    {
        "code": "ha",
        "name": ""
    },
    {
        "code": "haw",
        "name": ""
    },
    {
        "code": "he",
        "name": ""
    },
    {
        "code": "hi",
        "name": ""
    },
    {
        "code": "hil",
        "name": ""
    },
    {
        "code": "hmn",
        "name": ""
    },
    {
        "code": "hr",
        "name": ""
    },
    {
        "code": "hrx",
        "name": ""
    },
    {
        "code": "ht",
        "name": ""
    },
    {
        "code": "hu",
        "name": ""
    },
    {
        "code": "hy",
        "name": ""
    },
    {
        "code": "id",
        "name": ""
    },
    {
        "code": "ig",
        "name": ""
    },
    {
        "code": "ilo",
        "name": ""
    },
    {
        "code": "is",
        "name": ""
    },
    {
        "code": "it",
        "name": ""
    },
    {
        "code": "iw",
        "name": ""
    },
    {
        "code": "ja",
        "name": ""
    },
    {
        "code": "jv",
        "name": ""
    },
    {
        "code": "jw",
        "name": ""
    },
    {
        "code": "ka",
        "name": ""
    },
    {
        "code": "kk",
        "name": ""
    },
    {
        "code": "km",
        "name": ""
    },
    {
        "code": "kn",
        "name": ""
    },
    {
        "code": "ko",
        "name": ""
    },
    {
        "code": "kri",
        "name": ""
    },
    {
        "code": "ktu",
        "name": ""
    },
    {
        "code": "ku",
        "name": ""
    },
    {
        "code": "ky",
        "name": ""
    },
    {
        "code": "la",
        "name": ""
    },
    {
        "code": "lb",
        "name": ""
    },
    {
        "code": "lg",
        "name": ""
    },
    {
        "code": "li",
        "name": ""
    },
    {
        "code": "lij",
        "name": ""
    },
    {
        "code": "lmo",
        "name": ""
    },
    {
        "code": "ln",
        "name": ""
    },
    {
        "code": "lo",
        "name": ""
    },
    {
        "code": "lt",
        "name": ""
    },
    {
        "code": "ltg",
        "name": ""
    },
    {
        "code": "luo",
        "name": ""
    },
    {
        "code": "lus",
        "name": ""
    },
    {
        "code": "lv",
        "name": ""
    },
    {
        "code": "mai",
        "name": ""
    },
    {
        "code": "mak",
        "name": ""
    },
    {
        "code": "mg",
        "name": ""
    },
    {
        "code": "mi",
        "name": ""
    },
    {
        "code": "min",
        "name": ""
    },
    {
        "code": "mk",
        "name": ""
    },
    {
        "code": "ml",
        "name": ""
    },
    {
        "code": "mn",
        "name": ""
    },
    {
        "code": "mni-Mtei",
        "name": ""
    },
    {
        "code": "mr",
        "name": ""
    },
    {
        "code": "ms",
        "name": ""
    },
    {
        "code": "ms-Arab",
        "name": ""
    },
    {
        "code": "mt",
        "name": ""
    },
    {
        "code": "my",
        "name": ""
    },
    {
        "code": "ne",
        "name": ""
    },
    {
        "code": "new",
        "name": ""
    },
    {
        "code": "nl",
        "name": ""
    },
    {
        "code": "no",
        "name": ""
    },
    {
        "code": "nr",
        "name": ""
    },
    {
        "code": "nso",
        "name": ""
    },
    {
        "code": "nus",
        "name": ""
    },
    {
        "code": "ny",
        "name": ""
    },
    {
        "code": "oc",
        "name": ""
    },
    {
        "code": "om",
        "name": ""
    },
    {
        "code": "or",
        "name": ""
    },
    {
        "code": "pa",
        "name": ""
    },
    {
        "code": "pa-Arab",
        "name": ""
    },
    {
        "code": "pag",
        "name": ""
    },
    {
        "code": "pam",
        "name": ""
    },
    {
        "code": "pap",
        "name": ""
    },
    {
        "code": "pl",
        "name": ""
    },
    {
        "code": "ps",
        "name": ""
    },
    {
        "code": "pt",
        "name": ""
    },
    {
        "code": "qu",
        "name": ""
    },
    {
        "code": "rn",
        "name": ""
    },
    {
        "code": "ro",
        "name": ""
    },
    {
        "code": "rom",
        "name": ""
    },
    {
        "code": "ru",
        "name": ""
    },
    {
        "code": "rw",
        "name": ""
    },
    {
        "code": "sa",
        "name": ""
    },
    {
        "code": "scn",
        "name": ""
    },
    {
        "code": "sd",
        "name": ""
    },
    {
        "code": "sg",
        "name": ""
    },
    {
        "code": "shn",
        "name": ""
    },
    {
        "code": "si",
        "name": ""
    },
    {
        "code": "sk",
        "name": ""
    },
    {
        "code": "sl",
        "name": ""
    },
    {
        "code": "sm",
        "name": ""
    },
    {
        "code": "sn",
        "name": ""
    },
    {
        "code": "so",
        "name": ""
    },
    {
        "code": "sq",
        "name": ""
    },
    {
        "code": "sr",
        "name": ""
    },
    {
        "code": "ss",
        "name": ""
    },
    {
        "code": "st",
        "name": ""
    },
    {
        "code": "su",
        "name": ""
    },
    {
        "code": "sv",
        "name": ""
    },
    {
        "code": "sw",
        "name": ""
    },
    {
        "code": "szl",
        "name": ""
    },
    {
        "code": "ta",
        "name": ""
    },
    {
        "code": "te",
        "name": ""
    },
    {
        "code": "tet",
        "name": ""
    },
    {
        "code": "tg",
        "name": ""
    },
    {
        "code": "th",
        "name": ""
    },
    {
        "code": "ti",
        "name": ""
    },
    {
        "code": "tk",
        "name": ""
    },
    {
        "code": "tl",
        "name": ""
    },
    {
        "code": "tn",
        "name": ""
    },
    {
        "code": "tr",
        "name": ""
    },
    {
        "code": "ts",
        "name": ""
    },
    {
        "code": "tt",
        "name": ""
    },
    {
        "code": "ug",
        "name": ""
    },
    {
        "code": "uk",
        "name": ""
    },
    {
        "code": "ur",
        "name": ""
    },
    {
        "code": "uz",
        "name": ""
    },
    {
        "code": "vi",
        "name": ""
    },
    {
        "code": "xh",
        "name": ""
    },
    {
        "code": "yi",
        "name": ""
    },
    {
        "code": "yo",
        "name": ""
    },
    {
        "code": "yua",
        "name": ""
    },
    {
        "code": "yue",
        "name": ""
    },
    {
        "code": "zh",
        "name": ""
    },
    {
        "code": "zh-CN",
        "name": ""
    },
    {
        "code": "zh-TW",
        "name": ""
    },
    {
        "code": "zu",
        "name": ""
    }
]